import { render, staticRenderFns } from "./TemporaryItems.vue?vue&type=template&id=3f7dc460&scoped=true"
import script from "./TemporaryItems.vue?vue&type=script&lang=js"
export * from "./TemporaryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7dc460",
  null
  
)

export default component.exports